module.exports = __webpack_public_path__ + "img/hc_pro_five_1.54305f69.jpg";